import { LockClosedIcon } from "@heroicons/react/24/outline";

import ButtonRound from "src/common/buttons/ButtonRound";

import { BUTTONS_ROUND } from "src/utils/styles";

interface IntegrationConfigReAuthButtonProps {
  config: any;
}

export function IntegrationConfigReAuthButton({
  config,
}: IntegrationConfigReAuthButtonProps) {
  const shop = config.cartUserConfig.storeUrl;
  const authUrl = `https://${shop}/admin/oauth/authorize?client_id=f33181ed69280391b42603e074c5a2da&scope=write_third_party_fulfillment_orders,read_all_orders,read_orders,write_orders,read_assigned_fulfillment_orders,write_assigned_fulfillment_orders,read_fulfillments,write_fulfillments,read_inventory,write_inventory,read_products,read_locations,write_shipping,write_products&redirect_uri=https://integration.efulfillmentservice.com/integrations/oauth/reauth/ShopifyV2`;
  console.log(authUrl);
  if (!shop) return null;

  return (
    <div>
      <ButtonRound
        icon={
          <LockClosedIcon className={BUTTONS_ROUND.icon} aria-hidden="true" />
        }
        label={`re-auth ${shop}`}
        design="secondary"
        func={() => window.open(authUrl, "_blank")}
      />
    </div>
  );
}
